import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon pointer-cursor" }
const _hoisted_2 = { class: "contact" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }

import { Action } from '@/typeDefine/CommonTypes';
import { UtilMethods } from '@/util/UtilMethods';
import {  ref, Ref } from 'vue';
import email from '@/assets/images/email.png'
import wechat from '@/assets/images/wechat.png'
import whatsApp from '@/assets/images/whatsApp.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatButton',
  setup(__props, { expose: __expose }) {

const primaryColor: string = UtilMethods.getDOMStyleFromCSS('--primary-color')

//控制显示
const showOrHide: Ref<boolean> = ref(false)

//隐藏悬浮球
const floatButtonDisplayHandler: Action<[boolean]> = (value: boolean) => {
    showOrHide.value = !value
}

//需要暴露的方法
__expose({
    floatButtonDisplayHandler
})

return (_ctx: any,_cache: any) => {
  const _component_ChatDotRound = _resolveComponent("ChatDotRound")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
        'float-button-content','animate__animated ',showOrHide.value ? 'animate__fadeInRight' : 'animate__fadeOutRight'
    ]),
    ref: "floatButtonRef"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_popover, {
        trigger: "hover",
        placement: "left",
        title: _ctx.$t('index.floatButton.popoverTitle'),
        width: "200"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_icon, {
            class: "contact-icon",
            size: "40",
            color: 'green'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ChatDotRound)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_image, {
                style: {"width":"30px","height":"30px"},
                src: _unref(email),
                class: "icon"
              }, null, 8, ["src"]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contact-content" }, [
                _createElementVNode("p", null, "lc@lcodin.com"),
                _createElementVNode("p", null, "lc005@lcodin.com"),
                _createElementVNode("p", null, "lc003@lcodin.com")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                style: {"width":"30px","height":"30px"},
                src: _unref(wechat),
                class: "icon"
              }, null, 8, ["src"]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "contact-content" }, [
                _createElementVNode("p", null, "Leo_dydt"),
                _createElementVNode("p", null, "18279395441"),
                _createElementVNode("p", null, "19350886484")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                style: {"width":"30px","height":"30px"},
                src: _unref(whatsApp),
                class: "icon"
              }, null, 8, ["src"]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "contact-content" }, [
                _createElementVNode("p", null, "18666465246"),
                _createElementVNode("p", null, "008618279395441"),
                _createElementVNode("p", null, "008619350886484")
              ], -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ], 2))
}
}

})